import VFooter from './VFooter'

VFooter.install = function install (Vue) {
  Vue.component(VFooter.name, VFooter)
}

export default VFooter



// WEBPACK FOOTER //
// ./src/components/VFooter/index.js